import React, { useState } from 'react';
import BtnCircular from '../../../ds/BtnCircular/BtnCircular';
import { ReactComponent as CloseIcon } from '../../../icons/x.svg';
import BankPaymentBody from '../../molecules/BankPaymentBody/BankPaymentBody';
import { useContent, useLanguages } from '../../../hooks/content';
import BtnStandardIconText from '../../../ds/BtnStandardIconText/BtnStandardIconText';
import { Returntext } from '../../../pages/Landings/common/returnText';
import axios from 'axios';
import Lottie from 'lottie-react';
import LoaderAnimation from '../../../assets/animations/Loaders/1 - Green/data.json';
import Cookies from 'js-cookie';
import { useOrders, useUnpaidOrders } from '../../../hooks/orders';
import { useDispatch } from 'react-redux';
import { setB2BDrawerStep1, setB2BDrawerStep2 } from '../../../redux/actions';
import { useSnackbar } from 'notistack';
import { ReactComponent as BkpIcon } from '../../../icons/bkp.svg';
import ListItem from '../../../ds/ListItem/ListItem';
import { ReactComponent as EyeIcon } from '../../../icons/eye.svg';
import { ReactComponent as DownloadIcon } from '../../../icons/download2.svg';
import { ReactComponent as SusIcon } from '../../../icons/sus.svg';
import useMobileVhFix from '../../../hooks/height';

const BankPaymentContentS2 = ({ cancelClick, activeOrder, setActiveOrder }) => {
  const { lang } = useLanguages();
  const { contentManagementData } = useContent();

  const user = JSON.parse(localStorage.getItem('user'));
  const { refetchOrders, orders } = useOrders(
    user.id,
    'RECEIVED_IN_TBILISI_WAREHOUSE',
  );

  const [loader, setLoader] = useState(false);
  const access_token = Cookies.get('access_token');

  const dispatch = useDispatch();

  const { enqueueSnackbar } = useSnackbar();
  const { refetchUnpaidOrders } = useUnpaidOrders(user.id);

  const handleTransactionB2BStep2 = async () => {
    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL}/transactions/invoiceStatusChangeReject/${activeOrder?.id}?accessToken=${access_token}`,
      );

      await refetchOrders();
      refetchUnpaidOrders();
      const updatedOrder = orders.find((order) => order.id === activeOrder.id);
      if (updatedOrder) {
        setActiveOrder(updatedOrder);
      }

      setLoader(false);
      dispatch(setB2BDrawerStep2(false));

      enqueueSnackbar(
        Returntext(contentManagementData, 'ErrorMessages-cancelpayment', lang),
        {
          variant: 'success',
        },
      );
    } catch (error) {
      console.error('Error fetching data:', error);
      enqueueSnackbar(
        Returntext(
          contentManagementData,
          'ErrorMessages-cancelpayment_1',
          lang,
        ),
        {
          variant: 'error',
        },
      );
      setLoader(false);
    }
  };

  // Arrow function for handling click
  const handleNavigate = () => {
    const url = `/invoice/${activeOrder.payments[0]?.id}`;
    window.open(url, '_blank');
  };

  const [pA, setPA] = useState(false);

  useMobileVhFix();

  const DeleteFileConfirmation = (
    <div className="delete-item">
      <div className="delete-item-box">
        <div className="top">
          <div className="title">
            {Returntext(contentManagementData, 'suspend_payment_1', lang)}
          </div>
          <BtnCircular
            size={'sm'}
            mainColor={'white'}
            svg={<CloseIcon />}
            disabled={false}
            mode={'active'}
            onClick={() => {
              setPA(false);
            }}
          />
        </div>

        <div className="middle">
          <div className="txt">
            {Returntext(contentManagementData, 'suspend_payment_2', lang)}
          </div>
        </div>

        <div className="bottom">
          <BtnStandardIconText
            mode=""
            txt={Returntext(contentManagementData, 'suspend_payment_4', lang)}
            disabled={false}
            size={'standard'}
            icon={false}
            mainColor={'white'}
            onClick={() => {
              setPA(false);
            }}
          />
          <BtnStandardIconText
            mode=""
            txt={Returntext(contentManagementData, 'suspend_payment_3', lang)}
            disabled={false}
            size={'standard'}
            icon={false}
            mainColor={'red'}
            onClick={() => {
              handleTransactionB2BStep2();
            }}
          />
        </div>
      </div>
    </div>
  );

  return (
    <div className={`drawer-wrap ${loader && 'load'}`}>
      <div className="header">
        <div className="left"></div>

        <div className="middle">
          {Returntext(contentManagementData, 'pay_via_bank', lang)}
        </div>
        <BtnCircular
          size={'sm'}
          mainColor={'white'}
          svg={<CloseIcon />} // Use the SVG component here
          disabled={false}
          mode={'active'}
          onClick={cancelClick}
        />
      </div>

      {loader && (
        <div className="pd-loader">
          <Lottie animationData={LoaderAnimation} className="animation" />
        </div>
      )}

      <div className="body lg">
        <div className="tp-txt">
          <div className="mt">
            {Returntext(contentManagementData, 'bp_step_3_main_title', lang)}
          </div>
          <div className="st">
            {Returntext(contentManagementData, 'bp_step_3_main_body', lang)}
          </div>
        </div>

        <ListItem
          hasBorder={true}
          hasPadding={true}
          hasIcon={true}
          headline={`${Returntext(contentManagementData, 'invoice', lang)} ${activeOrder?.payments[0]?.invoice_number}`}
          icon={<BkpIcon />}
          buttons={
            <>
              <BtnCircular
                size={'sm'}
                mainColor={'grayBorder'}
                svg={<EyeIcon />}
                disabled={false}
                onClick={handleNavigate}
              />
              {/* <BtnCircular
                size={"sm"}
                mainColor={"grayBorder"}
                svg={<DownloadIcon />}
                disabled={false}
              /> */}
            </>
          }
        />

        <div className="suspend-box">
          <SusIcon className="sus" />

          <div className="txts">
            <div className="mn">
              {Returntext(contentManagementData, 'bp_step_3_title', lang)}
            </div>
            <div className="sn">
              {Returntext(contentManagementData, 'bp_step_3_body', lang)}
            </div>
          </div>

          <BtnStandardIconText
            mode=""
            txt={Returntext(contentManagementData, 'suspend_payment', lang)}
            disabled={false}
            size={'md'}
            icon={false}
            mainColor={'red'}
            onClick={() => setPA(true)}
          />
        </div>
      </div>

      {pA && DeleteFileConfirmation}
    </div>
  );
};

export default BankPaymentContentS2;
